import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';
import {t} from '@/i18n';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_calendar.breadcrumb.calendar_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_calendar.breadcrumb.calendar_label2'),
  },
];
